import { Flex } from "@redotech/redo-web/flex";
import { PageForm } from "@redotech/redo-web/page-form";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { PosGeneral, posGeneralDefault } from "./pos/general";
import { usePos } from "./pos/use-pos";

export const PosPage = memo(function PosPage() {
  const { posSettingsLoad, save, posInput } = usePos();

  if (posSettingsLoad.error) {
    return (
      <Flex>
        <Text textColor="error">{`Something went wrong loading pos settings: ${posSettingsLoad.error?.message}`}</Text>
      </Flex>
    );
  }

  return (
    <PageForm
      initial={posSettingsLoad.value || posGeneralDefault}
      input={posInput}
      save={save}
    >
      <PosGeneral posInput={posInput} />
    </PageForm>
  );
});
